import React from 'react';
import { NoData } from 'pages/Asset/tabs/Cases/components/NoData/NoData';
import { Evidence } from './Evidence';
import { AnalysisButtons } from '../AnalysisButtons/AnalysisButtons';
import { UploadIcon } from '../UploadIcon';
import { CaseForm, FileEvidences } from 'queries/cases/types';
import { UseFormHandleSubmit } from 'react-hook-form';

interface EvidenceContentProps {
  isLoading: boolean;
  assetId: string;
  evidences: FileEvidences[] | undefined;
  fileInputRef: React.RefObject<HTMLInputElement>;
  handleSubmit: UseFormHandleSubmit<CaseForm>;
}

export const EvidenceContent: React.FC<EvidenceContentProps> = ({
  isLoading,
  assetId,
  evidences,
  fileInputRef,
  handleSubmit,
}) => {
  if (isLoading) {
    return <NoData icon={null} i18nKey="case:evidences.no_data" isLoading={isLoading} />;
  }

  return (
    <>
      <UploadIcon data-testid="upload-icon" fileInputRef={fileInputRef} />
      <div className="evidences-wrapper" data-testid="evidence-component">
        <AnalysisButtons assetId={assetId} />

        {evidences?.map((file: FileEvidences, index: number) => (
          <Evidence {...file} index={index} key={file.name} handleSubmit={handleSubmit} />
        ))}
      </div>
    </>
  );
};
